import React from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'react-awesome-reveal';

export default function Service({ data }) {
  return (
    <div className="bg-gray-50 py-20 mb-24 sm:mb-18 xl:mb-16">
      <div className="container mx-auto">
        <Fade bottom triggerOnce>
          <h1 className="text-5xl text-theme-blue text-center font-bold">Onze app</h1>

          <p className="font-light text-lg text-gray-400 text-center mb-12 sm:mb-5 xl:mb-0">
            Een eenvoudige applicatie die je direct alles in handen geeft om je dromen te bereiken
          </p>
        </Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {data.map((item, index) => (
            <Fade bottom triggerOnce delay={500 * index} key={item.id}>
              <div className="flex flex-col items-center justify-between p-6 bg-white rounded-2xl shadow-xl border border-light-theme-purple transform transition duration-500 hover:scale-105 h-full">
                <img src={item.imageUrl} alt={item.title} className="w-full h-40 object-cover rounded-t-lg mb-4" />
                <div className="text-center">
                  <h2 className="text-theme-blue text-2xl font-bold mb-2">{item.title}</h2>
                  <p className="font-light text-gray-400">{item.description}</p>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
}

Service.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      imageUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
